import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const LayoutWrapper = styled.div`
  flex: 1;
  height: 100%;
  min-height: 100%;
  display: flex;
  /* border-top: 1px solid ${colors.secondary.lightGray3}; */
  min-width: 100%;
  /* border: 1px solid lime; */
`;
